/* Formulario de leads B2B (sections/pxs-companies.liquid).
 *
 * Hace dos envios con el mismo submit:
 *   1. Google Forms  -> queda registrado en la planilla de respuestas.
 *   2. EmailJS       -> avisa por correo al ejecutivo (correo "dinamico":
 *                       las variables salen de los bloques de la seccion).
 *
 * Por que EmailJS y no Resend: la API key de Resend es SECRETA y su propia
 * documentacion dice que no puede ir en el navegador. EmailJS esta disenado al
 * reves: usa una public key y plantillas predefinidas en su panel, asi que lo
 * peor que puede hacer alguien que copie la key es disparar TU plantilla con TU
 * contenido. Para usar Resend haria falta un proxy server-side (ver el README de
 * la seccion en docs/). No repetir el problema del x-api-secret de tt-wishlist.js.
 *
 * El script no asume nada del formulario: lee la config y los campos del JSON que
 * imprime la seccion, asi que agregar/quitar bloques en el editor no requiere
 * tocar este archivo.
 */
(function () {
  'use strict';

  var GOOGLE_FORMS_ENDPOINT = 'https://docs.google.com/forms/d/e/{id}/formResponse';

  function init(root) {
    if (root.dataset.pxsCompaniesInit) return;
    root.dataset.pxsCompaniesInit = '1';

    var cfgEl = root.querySelector('[data-companies-config]');
    var form = root.querySelector('[data-companies-form]');
    if (!cfgEl || !form) return;

    var cfg;
    try {
      cfg = JSON.parse(cfgEl.textContent);
    } catch (err) {
      return;
    }

    var status = root.querySelector('[data-companies-status]');
    var button = form.querySelector('[data-companies-submit]');
    var buttonLabel = button ? button.textContent : '';

    function setStatus(message, kind) {
      if (!status) return;
      status.textContent = message || '';
      status.hidden = !message;
      status.className =
        'pxs-companies__status' + (kind ? ' pxs-companies__status--' + kind : '');
    }

    /* Guardia anti-reenvío (por formulario): una vez enviado, no se vuelve a
     * suscribir. La llave es estable por form (Google Form id → si no, el id del
     * nodo o el path), así distintos formularios (venta-empresas/cursos/eventos)
     * no se pisan entre sí. */
    var storageKey = 'pxs_companies_sent__' + (cfg.googleFormId || root.id || location.pathname);
    function isAlreadySent() { try { return !!localStorage.getItem(storageKey); } catch (e) { return false; } }
    function markSent() { try { localStorage.setItem(storageKey, new Date().toISOString()); } catch (e) {} }

    /* Confetti + SweetAlert SOLO para este form. Si el CDN no cargó, se cae con
     * gracia al status inline de siempre → el envío nunca se rompe. */
    function celebrate() {
      if (typeof window.confetti !== 'function') return;
      try {
        window.confetti({ particleCount: 120, spread: 75, origin: { y: 0.6 }, zIndex: 20000 });
        setTimeout(function () {
          window.confetti({ particleCount: 80, spread: 100, origin: { y: 0.6 }, zIndex: 20000 });
        }, 250);
      } catch (e) {}
    }
    function alertSuccess() {
      if (window.Swal) {
        window.Swal.fire({
          icon: 'success',
          title: '¡Solicitud enviada! 🎉',
          text: cfg.successMessage || 'Te contactaremos pronto.',
          confirmButtonText: 'Perfecto',
          confirmButtonColor: '#036066'
        });
      } else {
        setStatus(cfg.successMessage, 'success');
      }
    }
    function alertError() {
      if (window.Swal) {
        window.Swal.fire({
          icon: 'error',
          title: 'Ups, algo falló',
          text: cfg.errorMessage || 'No pudimos enviar tu solicitud. Inténtalo de nuevo.',
          confirmButtonColor: '#e40e13'
        });
      } else {
        setStatus(cfg.errorMessage, 'error');
      }
    }
    // Estado "ya enviaste": oculta el botón y deja una nota persistente.
    function applySentState() {
      if (button) button.hidden = true;
      setStatus('✅ Ya recibimos tu solicitud. ¡Gracias! Te contactaremos pronto.', 'success');
    }

    function collect() {
      var out = [];
      var fields = form.querySelectorAll('[data-companies-field]');
      for (var i = 0; i < fields.length; i++) {
        var el = fields[i];
        out.push({
          entryId: el.getAttribute('data-entry-id') || '',
          varName: el.getAttribute('data-var-name') || el.name,
          label: el.getAttribute('data-label') || '',
          value: (el.value || '').trim()
        });
      }
      return out;
    }

    /* Google Forms no permite CORS: se envia con mode:'no-cors', que manda el
     * POST pero devuelve una respuesta opaca. O sea que NO se puede saber si
     * entro. Por eso el exito se decide con EmailJS (ver submit), y esto queda
     * como "mejor esfuerzo". */
    function sendToGoogleForms(data, meta) {
      if (!cfg.googleFormId) return Promise.resolve();

      var fd = new FormData();
      var any = false;
      data.forEach(function (f) {
        if (f.entryId) {
          fd.append('entry.' + f.entryId, f.value);
          any = true;
        }
      });

      /* Campos extra que NO son bloques del formulario: los completa el script.
       * El cliente nunca ve el Google Form (solo manda el POST por detras), asi
       * que todos los campos de ese form ya son invisibles para el: no hace falta
       * ningun truco para "ocultarlos".
       *
       * OJO con la fecha: Google Forms YA agrega una columna "Marca temporal" a la
       * hoja vinculada, generada en su servidor. Esta de aca sale del reloj del
       * visitante, asi que solo tiene sentido si se quiere el dato en horario de
       * Chile ya formateado. Si no, dejar el entry vacio y usar la de Google. */
      if (cfg.entryFecha && meta && meta.fechaHora) {
        fd.append('entry.' + cfg.entryFecha, meta.fechaHora);
        any = true;
      }
      if (cfg.entryOrigen && meta && meta.origen) {
        fd.append('entry.' + cfg.entryOrigen, meta.origen);
        any = true;
      }

      if (!any) return Promise.resolve();

      return fetch(GOOGLE_FORMS_ENDPOINT.replace('{id}', cfg.googleFormId), {
        method: 'POST',
        mode: 'no-cors',
        body: fd
      });
    }

    /* Datos que no vienen del formulario sino del contexto del envio.
     * Se calculan UNA vez por submit y los comparten Google Forms y EmailJS, asi
     * no quedan con horas distintas por milisegundos de diferencia.
     *
     * Sobre la fecha: sale del RELOJ DEL VISITANTE. Si lo tiene mal, llega mal.
     * Las fuentes confiables son server-side y ya existen: la columna "Marca
     * temporal" de la hoja de Google y la cabecera Date del propio correo.
     * `timeZone: America/Santiago` fuerza el huso chileno aunque el visitante
     * este viajando o tenga el dispositivo en otra zona. */
    function buildMeta() {
      var now = new Date();
      var fecha, hora;
      try {
        fecha = now.toLocaleDateString('es-CL', {
          timeZone: 'America/Santiago',
          weekday: 'long', day: '2-digit', month: 'long', year: 'numeric'
        });
        hora = now.toLocaleTimeString('es-CL', {
          timeZone: 'America/Santiago', hour: '2-digit', minute: '2-digit'
        });
      } catch (err) {
        // Navegador viejo sin soporte de timeZone: mejor algo que nada.
        fecha = now.toLocaleDateString('es-CL');
        hora = now.toLocaleTimeString('es-CL');
      }
      return {
        fecha: fecha,
        hora: hora,
        fechaHora: fecha + ' · ' + hora + ' hrs',
        origen: window.location.href
      };
    }

    function sendViaEmailJs(data, meta) {
      var e = cfg.emailjs || {};
      if (!e.serviceId || !e.templateId || !e.publicKey) return Promise.resolve(null);
      if (!window.emailjs) return Promise.reject(new Error('EmailJS no cargo'));

      // Las variables de la plantilla salen de cada bloque (var_name).
      var params = {};
      data.forEach(function (f) {
        if (f.varName) params[f.varName] = f.value;
      });

      params.fecha = meta.fecha;
      params.hora = meta.hora;
      params.fecha_hora = meta.fechaHora;
      params.page_url = meta.origen;

      // Resumen listo para pegar en la plantilla con {{resumen}}, util para no
      // tener que declarar cada variable a mano en EmailJS.
      params.resumen = data
        .map(function (f) { return (f.label || f.varName) + ': ' + f.value; })
        .join('\n') + '\n\nRecibido: ' + meta.fechaHora;

      return window.emailjs.send(e.serviceId, e.templateId, params, e.publicKey);
    }

    form.addEventListener('submit', function (ev) {
      ev.preventDefault();

      // Ya se suscribió antes (localStorage) → no reenviar.
      if (isAlreadySent()) {
        if (window.Swal) {
          window.Swal.fire({
            icon: 'info',
            title: 'Ya te registramos 🙌',
            text: 'Ya recibimos tu solicitud. Te contactaremos pronto.',
            confirmButtonColor: '#036066'
          });
        } else {
          setStatus('Ya recibimos tu solicitud. Te contactaremos pronto.', 'success');
        }
        return;
      }

      // Honeypot: los bots completan todos los inputs, incluido el oculto.
      var trap = form.querySelector('[data-companies-trap]');
      if (trap && trap.value) return;

      if (typeof form.reportValidity === 'function' && !form.reportValidity()) return;

      var data = collect();
      var meta = buildMeta();

      if (button) {
        button.disabled = true;
        button.textContent = cfg.sendingLabel || 'Enviando...';
      }
      setStatus('', '');

      // Los dos envios arrancan en paralelo. El veredicto lo da EmailJS, que es
      // el unico que devuelve una respuesta legible.
      var gf = sendToGoogleForms(data, meta).catch(function () { /* opaco, se ignora */ });

      sendViaEmailJs(data, meta)
        .then(function () { return gf; })
        .then(function () {
          markSent();
          form.reset();
          celebrate();
          alertSuccess();
          applySentState();
        })
        .catch(function () {
          alertError();
        })
        .then(function () {
          if (button && !button.hidden) {
            button.disabled = false;
            button.textContent = buttonLabel;
          }
        });
    });

    // Al cargar: si ya envió antes, muestra el estado "ya enviaste" (oculta el botón).
    if (isAlreadySent()) applySentState();
  }

  function boot() {
    var roots = document.querySelectorAll('[data-pxs-companies]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // El editor de temas re-renderiza la seccion sin recargar la pagina.
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-pxs-companies]');
    if (root) init(root);
  });
})();
